import { IVender } from "../../../model/respone/user/IVender";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eVenderActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IVender[],
    LOAD_ERRR: "",

    SHOW_EDIT_MODAL: {} as IVender | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IVender,
    SAVE_SUCCESS: undefined,
    SAVE_ERRR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERRR: "",

};
export const eVenderActionIds = generateActionTypeIds(
    eVenderActionsObj,
    "VENDER"
);
export type IVenderActionTypes = IGenericActionType<
    typeof eVenderActionsObj,
    "VENDER"
>;
